export default function updateStyle(element, newStyle, oldStyle) {
  // var res = 'no changes';
  if (!oldStyle) {
    oldStyle = {};
  }

  if (!_.isEqual(oldStyle, newStyle) || !element.dataset.styled) {
    element.dataset.styled = true;
    // res = 'Unset: ';
    _.each(oldStyle, function(v, k) {
      if (!newStyle[k]) {
        element.style.removeProperty(_.includes(k, '-') ? k : _.kebabCase(k));
        // res += k + ':[' + oldStyle[k] + ']->[null],';
      }
    });
    // res += ' Set: ';
    _.each(newStyle, function(v, k) {
      var important = '';
      if (_.endsWith(v, '!important')) {
        v = v.slice(0, -10);
        important = 'important';
      }

      element.style.setProperty(_.includes(k, '-') ? k : _.kebabCase(k), v, important);
      // res += k + ':[' + oldStyle[k] + ']->[' + v + '],';
    });
  }

  // return res;
}
